module.exports = __webpack_public_path__ + "static/media/sl.dcc4cc62.svg";